var render = function render(_c,_vm){return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:(
    `Ejemplo: ${
      _vm.props.row.data_formate === 'Entero'
        ? `0, 1, 2, ..., 100, ...`
        : `0.5, 1.2, ..., 10.56, ....`
    }`
  ),expression:"\n    `Ejemplo: ${\n      props.row.data_formate === 'Entero'\n        ? `0, 1, 2, ..., 100, ...`\n        : `0.5, 1.2, ..., 10.56, ....`\n    }`\n  ",modifiers:{"bottom":true}}]},[_vm._v("\n  "+_vm._s(_vm.props.row.data_formate)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }